<template>
  <div>
    <loading v-if="cargando" />
    <NavBarTop v-if="this.$store.state.auth" />
    <NavBarLeft v-show="this.$store.state.auth" />
    <div class="text-xs sidebar-mini-xs" :class="darkMode ? 'dark-mode' : ''">
      <transition name="fade-slide-rigth" mode="out-in">
        <router-view />
      </transition>
    </div>
    <ContentWrapper />
    <vue-progress-bar />
  </div>
</template>
<script>
import NavBarTop from "./components/layout/NavBarTop";
import NavBarLeft from "./components/layout/NavBarLeft";
import ContentWrapper from "./components/layout/ContentWrapper";
import Loading from "./components/LoadingSpinner";

export default {
  components: {
    NavBarTop,
    NavBarLeft,
    ContentWrapper,
    Loading,
  },

  data() {
    return {
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
      cargando: false,
    };
  },
  computed: {
    darkMode() {
      return this.$store.getters.getDarkMode;
    },
  },

  created() {
    this.$Progress.start();
    this.cargando = true;
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      this.cargando = true;
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
      this.cargando = false;
    });
  },

  methods: {
  },

  async mounted() {
    await this.$store.dispatch("getUser");
    await this.$store.dispatch("getMenus");
    await this.$store.dispatch("getPermissions");
    await this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
    await this.$store.dispatch("setRoutes");
    if (
      this.$store.getters.isAuthenticated &&
      this.$route.fullPath == "LoginForm"
    ) {
      return this.$router.replace("/");
    }
    await this.$Progress.finish();
    this.cargando = false;
  },
};
</script>

<style>
.bg-sts {
  background: linear-gradient(to bottom, #05a85a, #8fc74b);
}
.bg-sts-top-left {
  background: linear-gradient(to bottom, #05a85a, #8fc74b);
}

.bg-sts-green {
  background: #8fc74b;
}

.fade-slide-rigth-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-rigth-leave-active {
  transition: all 0.5s ease;
}
.fade-slide-rigth-enter,
.fade-slide-rigth-leave-to {
  transform: translateX(5%);
  opacity: 0;
}

.dark-vselect .vs__search::placeholder,
.dark-vselect .vs__dropdown-toggle,
.dark-vselect .vs__dropdown-menu,
.dark-vselect .vs__dropdown-option {
  background: #343a40;
  border: solid 1px #535b62;
  color: #fff;
  text-transform: lowercase;
  font-variant: small-caps;
}

.dark-vselect .vs__selected-options,
.dark-vselect .vs__selected,
.dark-vselect .vs__search,
.dark-vselect .vs__open {
  color: #fff;
}
.dark-vselect .vs__selected {
  background: #454d55;
}

.dark-vselect .vs__dropdown-option:hover {
  background: rgb(0, 4, 63);
}

.dark-vselect .vs__clear,
.dark-vselect .vs__open-indicator,
.dark-vselect .vs__deselect {
  fill: #fff;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  background: #b7b5b5 !important;
}

.vs__selected-options {
  flex-wrap: nowrap;
  max-width: calc(100%);
}

.vs__selected {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.error-vselect .vs__dropdown-toggle {
  border: solid thin #dc3545;
}
.ok-vselect .vs__dropdown-toggle {
  border: solid thin #28a745;
}

/* V-Select tamaño pequeño (form-control-sm) */
.form-control-sm.v-select .vs__dropdown-toggle,
.form-control-sm .vs__dropdown-toggle {
  min-height: calc(1.8125rem + 2px);
  padding: 0;
  font-size: 0.875rem;
}

.form-control-sm.v-select .vs__selected,
.form-control-sm .vs__selected {
  font-size: 0.875rem;
  margin: 2px 4px;
  padding: 0 4px;
}

.form-control-sm.v-select .vs__search,
.form-control-sm .vs__search {
  font-size: 0.875rem;
  margin: 2px 0;
  padding: 0 4px;
}

.form-control-sm.v-select .vs__actions,
.form-control-sm .vs__actions {
  padding: 2px 6px 0 3px;
}

.form-control-sm.v-select .vs__clear svg,
.form-control-sm .vs__clear svg,
.form-control-sm.v-select .vs__open-indicator,
.form-control-sm .vs__open-indicator {
  transform: scale(0.8);
}

.form-control-sm.v-select .vs__dropdown-menu,
.form-control-sm .vs__dropdown-menu {
  font-size: 0.875rem;
}

.form-control-sm.v-select .vs__dropdown-option,
.form-control-sm .vs__dropdown-option {
  padding: 4px 12px;
}

/* Color naranja personalizado (#ff7f40) */
.bg-orange {
  background-color: #ff7f40 !important;
}

.text-orange {
  color: #ff7f40 !important;
}

.badge-orange {
  color: #fff;
  background-color: #ff7f40;
}

.btn-orange {
  color: #fff;
  background-color: #ff7f40;
  border-color: #ff7f40;
}

.btn-orange:hover {
  color: #fff;
  background-color: #e66a2a;
  border-color: #d9601f;
}

.btn-outline-orange {
  color: #ff7f40;
  border-color: #ff7f40;
}

.btn-outline-orange:hover {
  color: #fff;
  background-color: #ff7f40;
  border-color: #ff7f40;
}

.border-orange {
  border-color: #ff7f40 !important;
}

.alert-orange {
  color: #7a3d1e;
  background-color: #ffe4d6;
  border-color: #ffd4be;
}

.card-orange:not(.card-outline) > .card-header {
  background-color: #ff7f40;
}

.card-orange:not(.card-outline) > .card-header,
.card-orange:not(.card-outline) > .card-header a {
  color: #fff;
}

.card-outline.card-orange {
  border-top: 3px solid #ff7f40;
}

.table-orange,
.table-orange > th,
.table-orange > td {
  background-color: #ffe4d6 !important;
}
</style>
